import { render, staticRenderFns } from "./MaidProductList.vue?vue&type=template&id=39217936&"
import script from "./MaidProductList.vue?vue&type=script&lang=js&"
export * from "./MaidProductList.vue?vue&type=script&lang=js&"
import style0 from "./MaidProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidProductList.vue"
export default component.exports